import App from "../website/App";
import OurProducts from "../website/sections/our-products/OurProducts";


window.App = App;
window.Section = OurProducts;